module.exports = __webpack_public_path__ + "static/media/loading-3.5d86b5da.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/loading-3.svg
// module id = 88
// module chunks = 7